"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringPropertyBaseDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var string_1 = require("@devexpress/utils/lib/utils/string");
var destination_type_1 = require("../utils/destination-type");
var destination_1 = require("./destination");
var StringPropertyBaseDestination = (function (_super) {
    tslib_1.__extends(StringPropertyBaseDestination, _super);
    function StringPropertyBaseDestination(importer, modifier) {
        var _this = _super.call(this, importer) || this;
        _this.value = [];
        _this.modifier = modifier;
        return _this;
    }
    Object.defineProperty(StringPropertyBaseDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.StringPropertyBaseDestination; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringPropertyBaseDestination.prototype, "controlCharHT", {
        get: function () { return StringPropertyBaseDestination.controlCharHT; },
        enumerable: false,
        configurable: true
    });
    StringPropertyBaseDestination.prototype.processCharCore = function (ch) {
        this.value.push(ch);
    };
    StringPropertyBaseDestination.prototype.afterPopRtfState = function () {
        var value = string_1.StringUtils.trim(this.value.join(""), ['\"', '\\s']);
        this.modifier(value);
    };
    StringPropertyBaseDestination.prototype.createClone = function () {
        return new StringPropertyBaseDestination(this.importer, this.modifier);
    };
    StringPropertyBaseDestination.controlCharHT = new map_creator_1.MapCreator()
        .add('\\', destination_1.DestinationBase.onEscapedChar)
        .get();
    return StringPropertyBaseDestination;
}(destination_1.DestinationBase));
exports.StringPropertyBaseDestination = StringPropertyBaseDestination;
